import request from "./request"
import endpoints from "./endpoints"

export const completeOrAssuredRequest = (setLoadingConfirm, prefix, suffix = "", summaryData, status, cmosUserInput, meterUserInput, selectedMeasureOptions, comments, setSummaryData, cleanUp) => {
  setLoadingConfirm(true)
  const inputParams = [
    "CF_VOA",
    "CF_VOA_Reason_Code",
    "CF_UPRN",
    "CF_UPRN_Reason_Code",
    "CF_Address_Line_1",
    "CF_Address_Line_2",
    "CF_Address_Line_3",
    "CF_Address_Line_4",
    "CF_Address_Line_5",
    "CF_Secondary_Addressable_Object",
    "CF_Primary_Addressable_Object",
    "CF_Postcode",
    "CF_Meter_GISX",
    "CF_Meter_GISY",
    "CF_Free_Descriptor",
    "CF_Meter_Address_Secondary_Addressable_Object",
    "CF_Meter_Address_Primary_Addressable_Object",
    "CF_Meter_Address_Address_Line_1",
    "CF_Meter_Address_Address_Line_2",
    "CF_Meter_Address_Address_Line_3",
    "CF_Meter_Address_Address_Line_4",
    "CF_Meter_Address_Address_Line_5",
    "CF_Meter_Address_Postcode",
    "CF_Meter_Address_Free_Desc"
  ]
  const filteredCmosUserInput = Object.fromEntries(
    Object.entries(cmosUserInput).filter(([key]) => inputParams.includes(key) && cmosUserInput[key] !== summaryData[key])
  )
  const filteredMeterUserInput = Object.fromEntries(
    Object.entries(meterUserInput).filter(([key]) => inputParams.includes(key) && meterUserInput[key] !== summaryData[key])
  )
  request(true).post(endpoints[`${prefix}_SELECT_MATCH`] + suffix, {
    spid: summaryData.Core_SPID,
    meterId: summaryData.Meter_ID,
    status: status,
    cmosUserInput: filteredCmosUserInput,
    meterUserInput: filteredMeterUserInput,
    ...(summaryData.Module && {module: summaryData.Module}),
    ...(selectedMeasureOptions && {
      measureOptions: {
        UPRN: selectedMeasureOptions.UPRN?.value ?? '',
        VOA: selectedMeasureOptions.VOA?.value ?? '',
        LTV: selectedMeasureOptions.LTV?.value ?? '',
        VWC: selectedMeasureOptions.VWC?.value ?? '',
        ADDRESS: selectedMeasureOptions.ADDRESS?.value ?? '',
      }
    }),
    ...(comments && {measureComments: comments})
  }).then(r => {
    setLoadingConfirm(false)
    if (!window.reloadCounts) {
      window.reloadSummaryData()
    } else {
      window.reloadCounts()
    }
    cleanUp()
  }).catch(error => {
    console.log(error)
    setLoadingConfirm(false)
  })
}